/**
 * Sliding Mini Cart Module
 * Wysuwany koszyk z prawej strony
 */
const slidingCart = {
    isUpdating: false,

    init() {
        this.bindEvents();
    },

    bindEvents() {
        const self = this;

        // Open cart - click on cart icon in header (desktop + mobile)
        $(document).on('click', '.header__menu-item-cart', function (e) {
            // Prevent the old dropdown from opening
            e.preventDefault();
            e.stopPropagation();
            self.openCart();
        });

        // Close cart - X button
        $(document).on('click', '.sliding-cart__close', function () {
            self.closeCart();
        });

        // Close cart - overlay
        $(document).on('click', '.sliding-cart-overlay', function () {
            self.closeCart();
        });

        // Close on ESC
        $(document).on('keyup', function (e) {
            if (e.key === 'Escape' && $('.sliding-cart').hasClass('active')) {
                self.closeCart();
            }
        });

        // Continue shopping button - close cart, then let the link navigate
        $(document).on('click', '.sliding-cart__btn--continue', function () {
            self.closeCart();
            // Let the default link navigation happen (href has the shop URL)
        });

        // Quantity plus
        $(document).on('click', '.sliding-cart__qty-plus', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (self.isUpdating) return;
            const cartItemKey = $(this).data('cart-item-key');
            const $input = $(this).siblings('.quantity').find('.qty');
            const currentQty = parseInt($input.val()) || 1;
            self.updateQuantity(cartItemKey, currentQty + 1);
        });

        // Quantity minus
        $(document).on('click', '.sliding-cart__qty-minus', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (self.isUpdating) return;
            const cartItemKey = $(this).data('cart-item-key');
            const $input = $(this).siblings('.quantity').find('.qty');
            const currentQty = parseInt($input.val()) || 1;
            if (currentQty > 1) {
                self.updateQuantity(cartItemKey, currentQty - 1);
            }
        });

        // Remove item
        $(document).on('click', '.sliding-cart__remove-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (self.isUpdating) return;
            const cartItemKey = $(this).data('cart-item-key');
            self.removeItem(cartItemKey);
        });
    },

    openCart() {
        if (!$('.sliding-cart').length) {
            return;
        }

        $('.sliding-cart').addClass('active');
        $('.sliding-cart-overlay').addClass('active');
        $('body').addClass('sliding-cart-open');

        // Prevent old dropdown
        $('.header__dropdown--cart').removeClass('active');
    },

    closeCart() {
        $('.sliding-cart').removeClass('active');
        $('.sliding-cart-overlay').removeClass('active');
        $('body').removeClass('sliding-cart-open');
    },

    showLoading() {
        if (!$('.sliding-cart__content .sliding-cart__loading').length) {
            $('.sliding-cart__content').css('position', 'relative').append('<div class="sliding-cart__loading"></div>');
        }
    },

    hideLoading() {
        $('.sliding-cart__loading').remove();
    },

    updateQuantity(cartItemKey, newQty) {
        const self = this;
        self.isUpdating = true;
        self.showLoading();

        $.ajax({
            url: settings.ajax_url,
            type: 'POST',
            data: {
                action: 'sliding_cart_update_qty',
                cart_item_key: cartItemKey,
                quantity: newQty
            },
            success: function (response) {
                if (response.success) {
                    self.refreshCartHTML(response.data.html);
                    self.updateHeaderCount(response.data.cart_count);
                }
                self.isUpdating = false;
                self.hideLoading();
            },
            error: function () {
                self.isUpdating = false;
                self.hideLoading();
            }
        });
    },

    removeItem(cartItemKey) {
        const self = this;
        self.isUpdating = true;
        self.showLoading();

        $.ajax({
            url: settings.ajax_url,
            type: 'POST',
            data: {
                action: 'sliding_cart_remove_item',
                cart_item_key: cartItemKey
            },
            success: function (response) {
                if (response.success) {
                    self.refreshCartHTML(response.data.html);
                    self.updateHeaderCount(response.data.cart_count);
                }
                self.isUpdating = false;
                self.hideLoading();
            },
            error: function () {
                self.isUpdating = false;
                self.hideLoading();
            }
        });
    },

    refreshCartHTML(html) {
        // The AJAX returns the full sliding-mini-cart.php HTML (overlay + cart)
        // Parse it and extract the parts we need
        const $parsed = $('<div>').html(html);
        const $newCart = $parsed.find('.sliding-cart');

        if ($newCart.length) {
            const $existingCart = $('.sliding-cart');

            // Replace header (title + count)
            const $newHeader = $newCart.children('.sliding-cart__header');
            if ($newHeader.length) {
                $existingCart.children('.sliding-cart__header').replaceWith($newHeader);
            }

            // Replace entire content section (items, summary, buttons, shipping - all inside)
            const $newContent = $newCart.children('.sliding-cart__content');
            if ($newContent.length) {
                $existingCart.children('.sliding-cart__content').replaceWith($newContent);
            }
        }
    },

    updateHeaderCount(count) {
        $('.header__link__span').text(count);
        $('.sliding-cart__count').text(count);

        // Trigger WC fragment refresh
        if (typeof wc_cart_fragments_params !== 'undefined') {
            $(document.body).trigger('wc_fragment_refresh');
        }
    },

    // Public method to open cart after adding item (used by add-to-cart-popup or directly)
    openAfterAdd() {
        const self = this;

        // Refresh the cart content first
        $.ajax({
            url: settings.ajax_url,
            type: 'POST',
            data: {
                action: 'sliding_cart_get_html'
            },
            success: function (response) {
                if (response.success) {
                    self.refreshCartHTML(response.data.html);
                    self.updateHeaderCount(response.data.cart_count);
                }
            }
        });
    }
};

export default slidingCart;

